import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import LoadingScreen from './LoadingScreen';
import AccessDisabledScreen from './AccessDisabledScreen';
import PendingApprovalPage from './PendingApprovalPage';
import RejectedPage from './RejectedPage';

function ProtectedRoute({ children }) {
  const { loading, user, isAdmin, encargado, productor, solicitud, profileError, signOut, refreshProfile } =
    useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Un administrador nunca ve el flujo de encargado/solicitud: tiene su
  // propio panel en /admin y no necesita (ni debe) existir en encargados.
  if (isAdmin) {
    return <Navigate to="/admin" replace />;
  }

  // Autorización real: SOLO public.encargados decide el acceso a App Campo.
  if (encargado?.activo && productor?.activo) {
    return children;
  }

  if (encargado) {
    // El encargado existe pero está deshabilitado, o su productor no es
    // válido (ver el mensaje específico en profileError).
    return (
      <AccessDisabledScreen
        message={profileError || 'Tu cuenta no está habilitada para acceder a la App de Campo.'}
        onRetry={refreshProfile}
        onSignOut={signOut}
      />
    );
  }

  if (solicitud?.estado === 'PENDIENTE') {
    return <PendingApprovalPage email={user.email} onSignOut={signOut} />;
  }

  if (solicitud?.estado === 'RECHAZADA') {
    return <RejectedPage motivo={solicitud.motivo_rechazo} onSignOut={signOut} />;
  }

  if (solicitud?.estado === 'APROBADA') {
    // Caso transitorio: la solicitud ya fue aprobada pero public.encargados
    // todavía no se creó. No debería durar — la aprobación completa debe
    // crear el encargado de forma atómica.
    return (
      <AccessDisabledScreen
        title="Configuración pendiente"
        message="Tu solicitud fue aprobada. Estamos terminando de configurar tu acceso, intenta nuevamente en unos minutos."
        onRetry={refreshProfile}
        onSignOut={signOut}
      />
    );
  }

  return (
    <AccessDisabledScreen
      message={profileError || 'No pudimos verificar tu acceso a la App de Campo.'}
      onRetry={refreshProfile}
      onSignOut={signOut}
    />
  );
}

export default ProtectedRoute;
